const F1PerTeamDriverLimits = {
    F1_PER_TEAM_DRIVER_LIMITS_SET_IS_USED: 'F1_PER_TEAM_DRIVER_LIMITS_SET_IS_USED',
    F1_PER_TEAM_DRIVER_LIMITS_SET_FOR_TEAM: 'F1_PER_TEAM_DRIVER_LIMITS_SET_FOR_TEAM',
    F1_PER_TEAM_DRIVER_LIMITS_SET_FOR_TEAMS: 'F1_PER_TEAM_DRIVER_LIMITS_SET_FOR_TEAMS',
    F1_MAX_PER_TEAM_DRIVERS_QUANTITY: 1,
};

export default F1PerTeamDriverLimits;
